<template>
	<div>
		<!-- 搜索筛选 -->
		<lcsj-filter @search="inputChange" @reset="clearAll">
			<el-form-item label="姓名：">
				<el-input v-model="formInline.chName" clearable size="small" placeholder="请输入姓名" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="登录类型：">
				<el-select v-model="formInline.mType" size="small" placeholder="请选择登录类型" style="width: 160px">
					<el-option v-for="item in loginTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="统计天数：">
				<el-select v-model="formInline.days" size="small" placeholder="请选择统计天数" style="width: 160px">
					<el-option v-for="item in dayOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="截止日期：">
				<el-date-picker
					v-model="formInline.endDate"
					type="date"
					size="small"
					value-format="yyyy-MM-dd"
					placeholder="默认为今天"
					:clearable="true"
				></el-date-picker>
			</el-form-item>
		</lcsj-filter>
		<div style="text-align: center">
			<h1>
				{{ formInline.endDate ? formInline.endDate + "为止" : "今日为止" }}近{{ formInline.days }}天系统人员登录次数统计
			</h1>
		</div>
		<!--列表-->
		<el-table :cell-class-name="$moneyCellClass"
			v-loading="loading"
			:data="listData"
			:row-key="(row) => row.chName"
			height="calc(100vh - 360px)"
			border
			stripe
			empty-text="暂无数据"
		>
			<el-table-column align="center" type="index" label="序号" width="60"></el-table-column>
			<el-table-column align="center" prop="chName" label="姓名" width="250"></el-table-column>
			<el-table-column v-for="(item, index) in listColumns" :key="index" align="center" :prop="`loginCount[${index}]`" :label="item" width="110"></el-table-column>
			<el-table-column align="center" prop="totalCount" label="合计" width="120" fixed="right"></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { GetUserLoginLogStatistic } from "@/api/userApi.js";

export default {
	data() {
		return {
			loading: false, // 显示加载
			formInline: {
				chName: "", // 姓名（模糊匹配）
				mType: 0, // 登录来源：0=全部 1=Web端 2=电子看板 3=APP
				days: 30,
				// 统计截止日期。注意：后端是 DateTime?，初值必须为 null ——
				// 传空字符串会让 System.Text.Json 反序列化失败，直接 400
				endDate: null
			},
			// 统计天数可选项（后端 UserLoginLogStatisticSearchDto.Days）
			dayOptions: [
				{ label: "近7 天", value: 7 },
				{ label: "近 15 天", value: 15 },
				{ label: "近 30 天", value: 30 },
				{ label: "近 60 天", value: 60 },
				{ label: "近 90 天", value: 90 }
			],
			// 登录类型（口径与登录日志列表页一致）
			loginTypeList: [
				{ label: "全部", value: 0 },
				{ label: "Web端", value: 1 },
				{ label: "电子看板", value: 2 },
				{ label: "APP", value: 3 }
			],
			listData: [],
			listColumns: []
		};
	},
	// 注册组件
	components: {},
	/**
	 * 创建完毕
	 */
	created() {
		this.getListData();
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		// 查询
		inputChange() {
			this.getListData();
		},
		// 重置筛选条件
		clearAll() {
			this.formInline.chName = "";
			this.formInline.mType = 0;
			this.formInline.days = 30;
			this.formInline.endDate = null;
			this.getListData();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetUserLoginLogStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data.dtls;
						this.listColumns = res.data.listColumns;
					} else {
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.year {
	color: var(--app-primary);
	position: absolute;
	left: -166px;
	top: 1px;
}
</style>
